'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _draftJs = require('draft-js');

var insertAtomicBlock = function insertAtomicBlock(editorState, entityType, mutability, data) {
  var character = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : ' ';

  var entityKey = editorState.getCurrentContent().createEntity(entityType, mutability, data).getLastCreatedEntityKey();
  return _draftJs.AtomicBlockUtils.insertAtomicBlock(editorState, entityKey, character);
};

exports.default = insertAtomicBlock;